import ENVIRONMENT from '@/environments/environment';

import Api from '../../utils/apiHelper';

const buildUrl = (baseUrl: string, endpoint: string, id: any, action: string) => `${baseUrl}${endpoint}/${id}${action}`;

const RetakenAPI = {
  postSimulateOrderRefunds: async (order: string, load: any) => {
    const url = buildUrl(ENVIRONMENT.URL_API_DASHBOARD, ENVIRONMENT.URL_ORDERS.ORDERS, order, ENVIRONMENT.URL_ORDERS.SIMULATE_REFUNDS);
    return Api.POST(url, load);
  },

  postOrderRefunds: async (order: string, load: any) => {
    const url = buildUrl(ENVIRONMENT.URL_API_DASHBOARD, ENVIRONMENT.URL_ORDERS.ORDERS, order, ENVIRONMENT.URL_ORDERS.REFUND);
    return Api.POST(url, load);
  },

  postSimulateLoanRefunds: async (loan: string, load: any) => {
    const url = buildUrl(ENVIRONMENT.URL_LOANS.API_LOAN, ENVIRONMENT.URL_LOANS.LOANS, loan, ENVIRONMENT.URL_LOANS.SIMULATE_REFUNDS_LOAN);
    return Api.POST(url, load);
  },

  postLoanRefunds: async (loan: string, load: any) => {
    const url = buildUrl(ENVIRONMENT.URL_LOANS.API_LOAN, ENVIRONMENT.URL_LOANS.LOANS, loan, ENVIRONMENT.URL_LOANS.REFUND_LOAN);
    return Api.POST(url, load);
  },
};

export const {
  postSimulateOrderRefunds,
  postOrderRefunds,
  postSimulateLoanRefunds,
  postLoanRefunds,
} = RetakenAPI;
